




















helpers = require('../../helpers.coffee')

view_model =
  data: ->
    contacts: []
    loading: false
    next_page: 1

  methods:
    loadContacts: (filters = {}) ->
      return if @loading || !@next_page
      @loading = true
      filters = Object.assign({}, filters)
      filters.user_id_eq = Session.current_user.id if !filters.user_id_eq && Session.current_user.isSeller()
      # filters = @mergeCurrentUserFilter(filters)
      @contact_resource.index @loadSuccess, Loader.off, params: {q: filters, page: @next_page}

    loadSuccess: (resources) ->
      @loading = false
      @next_page = resources.meta.next_page
      @contacts = @contacts.concat(resources.contacts)

    filter: (filters) ->
      @contacts = []
      @next_page = 1
      @loadContacts(filters)

    contactsEmpty: ->
      jQuery.isEmptyObject(@contacts)

  created: ->
    @contact_resource = new ContactsResource Session.current_company.id
    @loadContacts()

exports.default = helpers.vue_include(
  view_model, helpers.form,
  helpers.contacts.list_view_modes, helpers.filters
)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/contact_picker.vue